import React from 'react';
import PropTypes from 'prop-types';
import { MdLabelOutline } from 'react-icons/md';

const Tag = ({ text }) => {
  return (
    <div className="flex items-center bg-gray-200 rounded-full mt-1 px-3 py-1 text-sm font-semibold text-gray-800 mr-2">
      <MdLabelOutline className="mr-1" />
      <span>
        { text }
      </span>
    </div>
  );
};

Tag.propTypes = {
  text: PropTypes.string.isRequired,
};

export default Tag;
